// extracted by mini-css-extract-plugin
export default {"container":"info-description_container__CF2gO","title":"info-description_title__x3o6M","description":"info-description_description__4K6f1"};